import CommentSettings from './CommentSettings.svelte';

export let CommentWidgetApi = {
  Settings: (target, widget, onChange, refreshUI) => {
    return new CommentSettings({ target: target, props: { widget: widget, onChange: onChange, refreshUI: refreshUI } });
  }
};
